import { ButtonBoundary } from './button-boundary';

export const ActionBarBoundary = ButtonBoundary;
